// anime.js - https://animejs.com/
import anime from 'animejs/lib/anime.es.js';

const initialiseBlips = () => {
  const blipTimeline = anime.timeline({
    duration: 1500,
    easing: 'easeInOutSine',
    loop: true,
    autoStart: true,
  });

  blipTimeline.add({
    targets: '.blip__layer-2',
    opacity: [0.75, 0],
    scale: [0.5, 1.5],
  });

  blipTimeline.add({
    targets: '.blip__layer-3',
    opacity: [0.5, 0],
    scale: [0.5, 1.5],
    delay: -1500,
  });
};

exports.initialiseBlips = initialiseBlips;
